export const scaleLabels = {
  mmt: "MMT",
  rom: "ROM",
  rpe: "RPE",
  six_min_walk: "6MWT",
  peak_flow_meter_test: "PFMT",
  gcs: "GCS",
  ras_scale: "RAS",
  mas: "MAS",
  vcg: "VCG",
  moca: "MOCA",
  reflexes: "REFLEXES",
  asia: "ASIA",
  nihss: "NIHSS",
  coordination: "CT",
  finger_grip_test: "FGT",
  tcms: "TCMS",
  barthel: "BI",
};

export const opProgressScalesDisplayOrder = [
  "gcs",
  "ras_scale",
  "moca",
  "nihss",
  "asia",
  "mmt",
  "mas",
  "vcg",
  "rom",
  "coordination",
  "finger_grip_test",
  "tcms",
  "barthel",
  "rpe",
  "six_min_walk",
  "peak_flow_meter_test",
  "reflexes",
];
